<template>
    <div>
        <template v-if="viewPage == null"><preLoader></preLoader></template>
        <template v-if="viewPage == true">
        <div class="page-top mb-1 mb-3">
            <h1> Edit Student/Member </h1>
        </div>
        <div class="global-main">
            <form id="feeStudentForm" @submit.prevent="feeUpdateStudentData">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label> Campus/Branch<span class="highlight-color">*</span> </label>
                        <select v-model="form.student.campus_id" name="campus_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('student.campus_id') }" v-if="campuses != null">
                            <option value="" selected>Select Campus/Branch</option>
                            <option v-for="campus in campuses" v-bind:value="campus.id" v-bind:key="campus.id">
                                {{ campus.name }}
                            </option>
                        </select>
                        <has-error :form="form" field="campus_id"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Name<span class="highlight-color">*</span> </label>
                        <input v-model="form.student.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('student.name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Student/Member ID<span class="highlight-color">*</span> </label>
                        <input v-model="form.student.student_id" type="text" name="student_id" class="form-control" :class="{ 'is-invalid': form.errors.has('student.student_id') }" readonly>
                        <has-error :form="form" field="student_id"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Email Address<span class="highlight-color">*</span> </label>
                        <input v-model="form.student.email_address" type="text" name="email_address" class="form-control" :class="{ 'is-invalid': form.errors.has('student.email_address') }">
                        <has-error :form="form" field="email_address"></has-error>
                    </div>
                    <div class="form-group">
                        <label> CNIC NO.<span class="highlight-color">*</span> </label>
                        <input v-model="form.student.cnic_number" type="text" name="cnic_number" class="form-control" :class="{ 'is-invalid': form.errors.has('student.cnic_number') }">
                        <has-error :form="form" field="cnic_number"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Mobile Number<span class="highlight-color">*</span> </label>
                        <input v-model="form.student.mobile_number" type="text" name="mobile_number" class="form-control" :class="{ 'is-invalid': form.errors.has('student.mobile_number') }">
                        <has-error :form="form" field="mobile_number"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/feeStudents" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    student: null,
                }),
                campuses : null,
                viewPage : null

            }
        },
        methods: {
            feeUpdateStudentData() {
                this.$Progress.start();
                this.form.post('/api/feeUpdateStudentData/'+this.$route.params.id)
                .then(res => {
                  if(res.status=200){
                    if(res.data.code == 400 ){
                      this.$Progress.fail();
                      this.showAlertBox('error',res.data.msg);
                    }else{
                      this.$Progress.finish();
                      this.showToastBox('success','Student/Member updated successfully');
                      this.$router.push('/feeStudents');
                    }
                  }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                  }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getfeeEditStudentData(){
                this.$Progress.start();
                axios.get('/api/feeEditStudentData/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.campuses = res.data.campuses;
                        this.viewPage = res.data.viewPage;
                        this.form.student = res.data.student;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
                this.$Progress.fail();
            },
        },
        created() {
            this.getfeeEditStudentData();
        },
    }
</script>
